import React from 'react';
import Table    from '../../../../components/Table';
import View from './ViewParticipantes';
import usePermissions from '../../../../hooks/usePermissions';
import useAsyncStorage     from '../../../../hooks/useAsyncStorage';
import useAxios      from '../../../../hooks/useAxios';

const td  = [
  {
    label:"Nombre",
    field:"name",
    className:"",
    align:"left",
  },
  {
    label:"Apellidos",
    field:"surnames",
    className:"",
    align:"left",
  },
  {
    label:"Correo electrónico",
    field:"email",
    className:"",
    align:"left",
  },
  {
    label:"Teléfono",
    field:"celular",
    className:"",
    align:"left",
  },
  {
    label:"Acción",
    field:"event",
    className:"",
    align:"center",
    event:[
      {
        label:"Ver",
        action:"view",
        component:View,
      },
      {
        label:"Comentarios",
        action:"comments",
        subFixed:"gestor_evento_id_",
        component:true,
      },
    ]
  },
]
let axios;
let userStorage;
const Home=(props)=>{
  axios                 =   useAxios();
  userStorage           =   useAsyncStorage("perfiles");
  const permissions     =   usePermissions("clientes","index",{
                                                                skipSearch:true,
                                                                component:Table,
                                                                td:td,
                                                                create:View,
                                                                subFixed:"/Gestor de Eventos"
                                                              });

  React.useEffect(()=>{
    if (!userStorage.data) {
      const getInit=()=>{
        const endpoint    =  "api/"+process.env.REACT_APP_BACKEND_VERSION+"/info/roles"
        axios.getData({},endpoint).then((response)=>{
          if (response&&response.data) {
            userStorage.setData(response.data);
          }
        })
      }
      getInit()
    }
  },[])
  return  permissions.render()
}
export default Home
